import * as React from "react";
import { useRef } from "react";
import styled from "styled-components";
import useElementDimensions from "hooks/useElementDimensions";
const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  grid-row: 2;
  grid-column: 1;
`;
const FullSizeContainer = ({ children }) => {
  const element = useRef(null);
  const { width, height } = useElementDimensions(element);
  return /* @__PURE__ */ React.createElement(Wrapper, { ref: element }, children({ height, width }));
};
export default FullSizeContainer;
